import { cn } from '../../utils/cn';
import pt from '../../locales/pt';

function format(template, params) {
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    params[key] === undefined ? `{${key}}` : String(params[key]),
  );
}

/**
 * `.pen` `ds/wizard/step-indicator--segmented` (PJFXU) + instâncias das páginas
 * de onboarding (segmentos 5px, `$sage-500` cumprido / `$track` por cumprir).
 *
 * `phaseLabel` acrescenta o sufixo de fase ao contador («PASSO 2 DE 9 · SOBRE TI»),
 * como o `.pen` modela o progresso por fases (não há master de fases separado).
 */
export function WizardSegmentedProgress({
  step,
  total,
  className,
  showPercent = true,
  phaseLabel,
}) {
  const clamped = Math.max(1, Math.min(step, total));
  const pct = Math.round((clamped / total) * 100);
  const copy = pt.wizard.common;
  const stepText = format(copy.stepLabel, { current: clamped, total });
  const counter = phaseLabel ? `${stepText} · ${phaseLabel}` : stepText;

  return (
    <div
      data-ds-id="ds/wizard/step-indicator--segmented"
      className={cn('flex flex-col gap-space-2', className)}
    >
      <div className="flex items-center justify-between gap-space-2">
        <span className="min-w-0 truncate text-type-label font-normal uppercase tracking-[0.042em] text-muted-foreground">
          {counter}
        </span>
        {showPercent ? (
          <span className="shrink-0 font-mono text-type-label font-medium tabular-nums text-muted-foreground">
            {format(copy.percent, { pct })}
          </span>
        ) : null}
      </div>
      <div
        className="flex gap-space-1"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-label={counter}
      >
        {Array.from({ length: total }, (_, index) => (
          <span
            key={index}
            className={cn(
              // eslint-disable-next-line no-restricted-syntax -- altura do segmento (.pen 5px)
              'h-[5px] flex-1 rounded-ds-full transition-colors duration-300',
              index < clamped ? 'bg-sage-500' : 'bg-track',
            )}
          />
        ))}
      </div>
    </div>
  );
}

export default WizardSegmentedProgress;
